// extracted by mini-css-extract-plugin
module.exports = {"main":"display_main__23ydK","main2":"display_main2__3zge_"};